// extracted by mini-css-extract-plugin
export var container = "Copyrights-module--container--1VNzk";
export var inner = "Copyrights-module--inner--2HiDT";
export var brand = "Copyrights-module--brand--2MfKs";
export var text = "Copyrights-module--text--1vdTu";